import { Box } from '@mantine/core';
import { MonthPickerInput } from '@mantine/dates';
import 'dayjs/locale/sr';
import 'dayjs/locale/de';

import InputLabel from 'components/input-label';
import classes from './index.module.css';
import i18n from 'config/localization';

const CustomMonthPicker = ({
  label,
  required,
  ...props
}: any) => {
  const languageFromI18n = i18n.language.toLowerCase().split('-')[0] as 'EN' | 'DE' | 'SR' | 'AL' | 'ES' | 'FR' | 'IT' | 'PT' | 'TR';

  return (
    <Box>
      {label ? <InputLabel label={label} required={required} /> : undefined}
      <MonthPickerInput
        classNames={{ input: classes.input }}
        withAsterisk={props.required}
        clearable={true}
        {...props}
        locale={languageFromI18n}
      />
    </Box>
  )
};

export default CustomMonthPicker;